export function downloadLocalFile(file: string, name: string) {
  const link = document.createElement("a");
  link.href = file;
  link.download = name;

  document.body.append(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(link.href), 7000);
}
